import { t } from "i18next";

import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button } from "@mui/material";

interface ShowHiddenAuctionsButtonProps {
  showHiddenAuctions: boolean;
  onToggle: () => void;
}

const ShowHiddenAuctionsButton = ({
  showHiddenAuctions,
  onToggle
}: ShowHiddenAuctionsButtonProps) => {
  return (
    <Button
      onClick={onToggle}
      variant={showHiddenAuctions ? "contained" : "outlined"}
      color="primary"
      startIcon={<VisibilityIcon />}
      sx={(theme) => ({
        width: {
          xs: "100%",
          sm: "auto"
        },
        fontSize: theme.typography.overline.fontSize,
        fontWeight: theme.typography.fontWeightBold,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      })}
    >
      {t("dealer.showHiddenAuctions")}
    </Button>
  );
};

export default ShowHiddenAuctionsButton;
